// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { setRouter } from '@/api';
import store from './store'
import WebFont from 'webfontloader';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles.css';
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css'

const getBaseURL = () => {
  if (window.location.hostname.includes('www.cambro.com')) {
    return 'https://www.cambro.com/storesafe';
  }
  return 'https://storesafe.fyi/storesafe';
};

axios.defaults.withCredentials = true;
axios.defaults.baseURL = getBaseURL();

const app = createApp(App);
setRouter(router);
WebFont.load({
  google: {
    families: ['Rajdhani:300,400,500,600,700']
  }
});
app.use(router);
app.use(store);
app.mount('#app');